import { Utils } from "@/plugins/utils"
import ReasonsRegistrationDomain from "../../domain/VD0/reasonsRegistrationDomain"

export default {
	namespaced: true,
	state: {
		lstVd0: [],
		vd0: null,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		insert: false,
		update: false,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getVd0(state) {
			return ReasonsRegistrationDomain.normalize(state.vd0)
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		setVd0(state, vd0) {
			state.vd0 = ReasonsRegistrationDomain.normalize(vd0)
		},
		initForm(state) {
			state.vd0 = null
			state.insert = false
			state.update = false
		},
		initSearchForm(state) {
			state.lstVd0 = []
		},
		setParamsDataTable(state, payload) {
			state.lstVd0 = (payload.items || []).map(x => ReasonsRegistrationDomain.normalize(x))
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLstVd0(state, lst) {
			state.lstVd0 = (lst || []).map(x => ReasonsRegistrationDomain.normalize(x))
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setInsert(state, insert) {
			state.insert = insert
		},
		setUpdate(state, update) {
			state.update = update
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		setSearch({ commit }, search) {
			commit("setSearch", search)
		},
		async find({ commit, dispatch }, Vd0motivo) {
			commit("setLoading", true)
			commit("initForm")

			await this._vm.$axios
				.get(`/OryxPlace/ReasonsRegistration/Find/${encodeURIComponent(Vd0motivo)}`)
				.then(response => {
					const vd0 = Utils.ValidateAxiosResponse(response.data)
					commit("setVd0", vd0)
					commit("setUpdate", true)
					return vd0
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})

			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initSearchForm")

			const query = `/OryxPlace/ReasonsRegistration/Search?search=${encodeURIComponent(
				getters.getSearch,
			)}&limit=${limit}&page=${page}`

			const payload = await this._vm.$axios
				.get(query)
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", data)
					return true
				})
				.catch(error => {
					commit("setLstVd0", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			commit("setLoading", false)
			return payload
		},
		async insert({ commit, dispatch }, vd0Model = null) {
			commit("setLoading", true)

			const data = ReasonsRegistrationDomain.normalize(vd0Model)

			const payload = await this._vm.$axios
				.post("/OryxPlace/ReasonsRegistration/Insert", data)
				.then(response => {
					const vd0 = Utils.ValidateAxiosResponse(response.data)
					commit("setVd0", vd0)
					commit("setInsert", true)
					commit("setUpdate", false)
					return vd0
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao inserir",
						},
						{ root: true },
					)
					return false
				})

			commit("setLoading", false)
			return payload
		},
		async update({ commit, dispatch }, vd0Model = null) {
			commit("setLoading", true)

			const data = ReasonsRegistrationDomain.normalize(vd0Model)

			const payload = await this._vm.$axios
				.put("/OryxPlace/ReasonsRegistration/Update", data)
				.then(response => {
					const vd0 = Utils.ValidateAxiosResponse(response.data)
					commit("setVd0", vd0)
					commit("setUpdate", true)
					commit("setInsert", false)
					return vd0
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao atualizar",
						},
						{ root: true },
					)
					return false
				})

			commit("setLoading", false)
			return payload
		},
		async delete({ commit, dispatch }, Vd0motivo) {
			commit("setLoading", true)

			const payload = await this._vm.$axios
				.delete(`/OryxPlace/ReasonsRegistration/Delete/${encodeURIComponent(Vd0motivo)}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao excluir",
						},
						{ root: true },
					)
					return false
				})

			commit("setLoading", false)
			return payload
		},
		async exists({ dispatch }, Vd0motivo) {
			return await this._vm.$axios
				.get(`/OryxPlace/ReasonsRegistration/Exists/${encodeURIComponent(Vd0motivo)}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao verificar existência",
						},
						{ root: true },
					)
					return false
				})
		},
	},
}
